<template>
    <div>
        <h3>{{ (source.hasOwnProperty('id')) ? 'Survey Source Settings' : 'Create A New Survey Source' }}</h3>
        
        
        <form class="large-form">

            <div class="form-line">
                <div class="form-field" >
                    <div class="small-note" style="margin-bottom: 0"><span>Survey Sources</span> are unique links that all go to your survey. You can use them to segment and compare your audience.</div>
                </div>
            </div>
            
            <div class="form-line" v-if="model.type">
                <div class="form-field" id="form-field-source-type">
                    <label for="form-input-source-type">Type</label>
                    <WSSelect v-model="model.type" :options="sourceTypes" />
                </div>
            </div>
            
            <div class="form-line">
                <div class="form-field" id="form-field-name" style="width: 100%;">
                    <label for="form-input-name">Source Name</label>
                    <input id="form-input-name" type="text" v-model="model.name" required @keyup="generateSlug" @paste="generateSlug">
                </div>
            </div>
           
            <div class="form-line">
                <div class="form-field" id="form-input-slug">
                    <label for="form-input-slug">Slug</label>
                    <input id="form-input-slug" type="text" v-model="model.slug" required @keyup="slugify = false" @paste="slugify = false">
                    <div class="field-note">This will be a part of the unique survey link.</div>
                </div>
            </div>
            <!--
            <div v-if="model.type === 'social'" class="form-line">
                <div class="form-field" id="form-field-platform">
                    <label for="form-input-platform">Platform</label>
                    <WSSelect v-model="model.platform" :options="platformTypes" />
                </div>
            </div>
            
            <div v-if="model.type === 'campaign'" class="form-line">
                <div class="form-field" id="form-field-campaign">
                    <label for="form-input-campaign">Campaign</label>
                    <WSSelect v-model="model.campaign_id" :options="activeCampaigns" />
                </div>
            </div>-->
            
            
            <div class="form-line" v-if="source.hasOwnProperty('id')">
                <div class="form-field" id="form-field-status">
                    <label for="form-input-status">Status</label>
                    <WSSelect v-model="model.active" :options="[
                        {value: false, text: 'Disabled'},
                        {value: true, text: 'Active'},
                    ]" />
                </div>
            </div>

            <div class="modal-errors" v-if="error">
                <p class="form-field error-text">{{ error.message }}</p>
            </div>
        </form>
        <div class="form-actions">
            <div class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div class="ws-button ws-button-main" @click="onSubmit">{{ (source.hasOwnProperty('id')) ? 'Save' : 'Add Source' }}</div>
        </div>
    </div>
</template>

<script>
import { snakeCase } from "lodash-es";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'SurveySourceForm',
    components: {WSSelect},
    props: {
        source: {
            type: Object,
            default: () => ({
                name: undefined,
                type: 'link',
                slug: undefined,
                //platform: undefined,
                //campaign_id: undefined,
                active: true,
            })
        },
        error: {
            type: Object
        }
    },
    data() {
        return {
            slugify: true,
            model: {
                name: undefined,
                type: 'link',
                slug: undefined,
                //platform: undefined,
                //campaign_id: undefined,
                active: true,
            },
            sourceTypes: [
                {value: 'campaign', text: 'Bookblock HUB Campaign', hidden: true},
                {value: 'link', text: 'General Unique Link'},
                {value: 'facebook', text: 'Social Media Link - Facebook'},
                {value: 'instagram', text: 'Social Media Link - Instagram'},
                {value: 'twitter', text: 'Social Media Link - Twitter'},
                {value: 'linkedin', text: 'Social Media Link - Linkedin'},
                {value: 'social', text: 'Social Media', hidden: true},
                //{value: 'embed', text: 'Web Embed'},
            ],
            socials: ['facebook','instagram','twitter','linkedin'],
        }
    },
    computed: {
        activeCampaigns() {
            return this.$store.state.giftBoxCampaign.index.data
                    .map(({id, name}) => ({text: name, value: id}))
        }
    },
    created() {
        if (this.source) this.model = {
            id: this.source.id,
            name: this.source.name,
            type: this.source.type === 'social' ? this.source.platform : this.source.type,
            slug: this.source.slug,
            active: this.source.active
        };
        
        if (!this.activeCampaigns.length) {
            this.$store.dispatch('fetchGiftBoxCampaigns')
        }
    },
    methods: {
        generateSlug() {
            if (this.slugify && !this.source.id) {
                this.model.slug = snakeCase(this.model.name).replaceAll('_', '-')
            }
        },
        onSubmit() {
            if (this.socials.includes(this.model.type)) {
                this.model.platform = this.model.type;
                this.model.type = 'social';
            }
            this.$emit('save', {...this.model})
        },
        onCancel() {
            this.$emit('cancel')
        },
    },
}
</script>
